import NextImage from '@/components/NextImage';
import EFPic from '@/components/UI/EFPic';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFAddress from '@/components/UI/svg/WTB/EFAddress';
import EFClock from '@/components/UI/svg/WTB/EFClock';
import EFDownloadArrow from '@/components/UI/svg/WTB/EFDownloadArrow';
import EFDownloadPhone from '@/components/UI/svg/WTB/EFDownloadPhone';
import EFDownloadPicture from '@/components/UI/svg/WTB/EFDownloadPicture';
import EFEmail from '@/components/UI/svg/WTB/EFEmail';
import EFGlobal from '@/components/UI/svg/WTB/EFGlobal';
import EFLocation from '@/components/UI/svg/WTB/EFLocation';
import EFNoData from '@/components/UI/svg/WTB/EFNoData';
import EFPageArrow from '@/components/UI/svg/WTB/EFPageArrow';
import EFPhone from '@/components/UI/svg/WTB/EFPhone';
import EFZip from '@/components/UI/svg/WTB/EFZip';
import { getOutlyingIslandsStores } from '@/constants/where-to-buy';
import { getCityList, getCountryList, getStateList, getStoreList, getTypeList } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { Input, Select } from 'antd';
import css from './index.module.scss';

export default function WhereToBuyH5() {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const PER_PAGE_MAX = 3;
    const [active, setActive] = useState(locale === 'ca' ? 'offcial' : 'retail');
    const [storeLists, setStoreLists] = useState([]);
    const [curPageStores, setCurPageStores] = useState([]);
    const [curPage, setCurPage] = useState(1);

    const [countryData, setCountryData] = useState([]);
    const [provinceData, setProvinceData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [typeData, setTypeData] = useState([]);

    const [countryOpen, setCountryOpen] = useState(false);
    const [provinceOpen, setProvinceOpen] = useState(false);
    const [cityOpen, setCityOpen] = useState(false);
    const [typeOpen, setTypeOpen] = useState(false);

    const [searchCountry, setSearchCountry] = useState(null);
    const [searchProvince, setSearchProvince] = useState(null);
    const [searchCity, setSearchCity] = useState(null); // 仅中国站
    const [searchType, setSearchType] = useState(null);
    const [searchText, setSearchText] = useState(null);

    const [hoverActive, setHoverActive] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const SEARCH_VAR_SITES: string[] = ['us', 'ca', 'de', 'au', 'ph', 'jp', 'it', 'es', 'fr', 'eu', 'uk', 'br', 'mx'];
    const SEARCH_VAR_SITES_STORE: string[] = ['sa'];
    const [expanded, setExpanded] = useState(false);
    const [searchVar, setSearchVar] = useState(SEARCH_VAR_SITES.includes(locale) ? 'zip' : SEARCH_VAR_SITES_STORE.includes(locale) ? 'text' : ''); // text => 地址或店名, zip => 邮编 两种
    const [countryStores, setCountryStores] = useState([]);

    // us 离岛门店卡片
    const storesAll = getOutlyingIslandsStores(locale);
    const [curPage1, setCurPage1] = useState(1);
    const PAGE_NUM = 3;
    const [stores, setStores] = useState(storesAll?.slice(PAGE_NUM * (curPage1 - 1), PAGE_NUM * curPage1));

    const LOCAL_MAP: any = {
        de: 'Germany',
        it: 'Italy',
        es: 'Spain',
        fr: 'France',
        us: 'United States',
        au: 'Australia',
        ph: 'Philippines',
        jp: 'Japan',
        lu: 'Luxembourg',
        cn: 'China',
        ca: 'Canada',
        eu: 'Germany',
        uk: 'United Kingdom',
        sa: 'Saudi Arabia',
        br: 'Brasil',
        mx: 'Mexico',
    };

    const onSearch = async (v: string) => {
        const params: any = {};
        searchVar === 'zip' ? (params.zipCode = v) : (params.fuzzyStr = v);
        if (searchCountry) {
            params.country = searchCountry;
        }
        if (searchProvince) {
            params.state = searchProvince;
        }
        if (searchCity && locale === 'cn') {
            params.city = searchCity;
        }
        if (searchType) {
            params.type = searchType;
        }
        const res = await getStoreList(params, locale);
        if (res.code === '0') {
            // 更新门店数据
            setStoreLists(res.data);
            setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
            setCurPage(1);
        }
    };

    const onSearchChange = (e: any) => {
        setSearchText(e.target.value);
    };

    const onChangeCountry = async (_k: any, v: any) => {
        if (v && v?.value) {
            // 1. 请求省/州数据
            const res = await getStateList({ country: v.value }, locale);
            if (res.code === '0') {
                setProvinceData(res.data);
                setSearchCountry(v.value);
                setSearchProvince(null);
                setSearchType(null);
            }
            // 2. 更新地图门店数据（选中国家下的）
            const params: any = { country: v.value };
            // if(searchType){
            //     params.type = searchType
            // }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                setStoreLists(resStores.data);
                setCountryStores(resStores.data);
                setCurPageStores(resStores.data.slice(0, PER_PAGE_MAX));
                setCurPage(1);
            }
            if (locale !== 'cn') {
                // 3. 更新类型
                const resType = await getTypeList({ country: v.value }, locale);
                if (resType.code === '0') {
                    setTypeData(resType.data);
                }
            }
        }
    };

    const onChangeProvince = async (_k: any, v: any) => {
        if (v && v?.value) {
            setSearchProvince(v.value);
            // 1. 请求城市数据
            if (locale === 'cn') {
                const res = await getCityList({ country: searchCountry, state: v.value }, locale);
                if (res.code === '0') {
                    setCityData(res.data);
                    setSearchCity(null);
                }
            }
            // 2. 更新地图门店数据（选中省/州下的）
            const params: any = { country: searchCountry, state: v.value };
            if (searchType) {
                params.type = searchType;
            }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                setStoreLists(resStores.data);
                setCurPageStores(resStores.data.slice(0, PER_PAGE_MAX));
                setCurPage(1);
            }
        }
    };

    const onChangeCity = async (_k: any, v: any) => {
        if (v && v?.value) {
            setSearchCity(v.value);
            // 2. 更新地图门店数据（选中城市下的）
            const params: any = { country: 'CN', state: searchProvince, city: v.value };
            if (searchType) {
                params.type = searchType;
            }
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                setStoreLists(resStores.data);
                setCurPageStores(resStores.data.slice(0, PER_PAGE_MAX));
                setCurPage(1);
            }
        }
    };

    const onChangeType = async (_k: any, v: any) => {
        if (v && v?.value) {
            setSearchType(v.value);
            // 更新地图门店数据（选中类型下的）
            const params: any = { type: v.value };
            if (searchText) {
                searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
            }
            if (searchCountry) {
                params.country = searchCountry;
            }
            if (searchProvince) {
                params.state = searchProvince;
            }
            if (searchCity && locale === 'cn') {
                params.city = searchCity;
            }
            const resStores = await getStoreList(params, locale);
            if (resStores.code === '0') {
                // 更新门店数据
                setStoreLists(resStores.data);
                setCurPageStores(resStores.data.slice(0, PER_PAGE_MAX));
                setCurPage(1);
            }
        }
    };

    const onPrevPage = () => {
        if (curPage > 1) {
            setCurPage(curPage - 1);
            setCurPageStores(storeLists.slice(PER_PAGE_MAX * (curPage - 2), PER_PAGE_MAX * (curPage - 1)));
        }
    };

    const onNextPage = () => {
        if (curPage < Math.ceil(storeLists.length / PER_PAGE_MAX)) {
            setCurPage(curPage + 1);
            setCurPageStores(storeLists.slice(PER_PAGE_MAX * curPage, PER_PAGE_MAX * (curPage + 1)));
        }
    };

    const onPrevPage1 = () => {
        if (curPage1 > 1) {
            window.scrollTo({ top: (window.innerWidth / 375) * 120 });
            setCurPage1(curPage1 - 1);
            setStores(storesAll.slice(PAGE_NUM * (curPage1 - 2), PAGE_NUM * (curPage1 - 1)));
        }
    };

    const onNextPage1 = () => {
        if (curPage1 < Math.ceil(storesAll.length / PAGE_NUM)) {
            window.scrollTo({ top: (window.innerWidth / 375) * 120 });
            setCurPage1(curPage1 + 1);
            setStores(storesAll.slice(PAGE_NUM * curPage1, PAGE_NUM * (curPage1 + 1)));
        }
    };

    // 品牌
    const brandsMap: any = {
        us: {
            country: 'United States',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/1.webp', '/media/wheretobuy/offcial/h5/1.png'], link: 'https://us.ecoflow.com/' },
                {
                    img: ['/media/wheretobuy/offcial/h5/2.webp', '/media/wheretobuy/offcial/h5/2.png'],
                    link: 'https://www.amazon.com/stores/EFECOFLOW/page/4BFF29AC-A220-4ABD-AFDC-9D612039F6A1?ref_=ast_bln',
                },
                { img: ['/media/wheretobuy/offcial/h5/3.webp', '/media/wheretobuy/offcial/h5/3.png'], link: 'https://www.rei.com/search?q=ECOFLOW' },
                {
                    img: ['/media/wheretobuy/offcial/h5/4.webp', '/media/wheretobuy/offcial/h5/4.png'],
                    link: 'https://www.homedepot.com/b/Outdoors-Outdoor-Power-Equipment-Generators-Portable-Power-Stations-Battery-Generators/EcoFlow/N-5yc1vZ2fkoqhoZndu/Ntk-elasticplus/Ntt-ecoflow?Ntx=mode+matchpartialmax&NCNI-5&visNavSearch=ecoflow',
                },
                { img: ['/media/wheretobuy/offcial/h5/5.webp', '/media/wheretobuy/offcial/h5/5.png'], link: 'https://www.costco.com/ecoflow-schedule.html' },
                { img: ['/media/wheretobuy/offcial/h5/6.webp', '/media/wheretobuy/offcial/h5/6.png'] },
                { img: ['/media/wheretobuy/offcial/h5/7.webp', '/media/wheretobuy/offcial/h5/7.png'], link: 'https://www.lowes.com/search?searchTerm=ecoflow' },
                { img: ['/media/wheretobuy/offcial/h5/8.webp', '/media/wheretobuy/offcial/h5/8.png'], link: 'https://www.tractorsupply.com/tsc/brand/EcoFlow' },
                { img: ['/media/wheretobuy/offcial/h5/9.webp', '/media/wheretobuy/offcial/h5/9.png'], link: 'https://www.target.com/s?searchTerm=EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/h5/10.webp', '/media/wheretobuy/offcial/h5/10.png'],
                    link: 'https://www.bestbuy.com/site/searchpage.jsp?st=ecoflow&_dyncharset=UTF-8&_dynSessConf=&id=pcat17071&type=page&sc=Global&cp=1&nrp=&sp=&qp=&list=n&af=true&iht=y&usc=All+Categories&ks=960&keys=keys',
                },
                { img: ['/media/wheretobuy/offcial/h5/11.webp', '/media/wheretobuy/offcial/h5/11.png'], link: 'https://www.ebay.com/str/ecoflowofficial' },
                { img: ['/media/wheretobuy/offcial/h5/12.webp', '/media/wheretobuy/offcial/h5/12.png'], link: 'https://www.walmart.com/search?q=EF+EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/h5/13.webp', '/media/wheretobuy/offcial/h5/13.png'],
                    // link: 'https://www.northerntool.com/shop/tools/NTESearch?storeId=6970&ipp=48&Ntt=ecoflow',
                    link: 'https://www.northerntool.com/brands/ecoflow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/20.webp', '/media/wheretobuy/offcial/pc/20.png'],
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                    link: 'https://www.harborfreight.com/search?q=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/22.webp', '/media/wheretobuy/offcial/pc/22.jpg'],
                    link: 'https://shopsolarkits.com/#/c2529e94-5ed2-4057-b71d-9332d34d96ca/embedded/autofilters=true&page=1&query=ECOFLOW&query_name=match_none&rpp=50',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                    link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                },
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1749526654320/campervanhq.png'],
                    link: 'https://www.campervan-hq.com/',
                },
            ],
        },
        'us-vi': {
            country: 'U.S. Virgin Islands',
            brands: [
                {
                    img: ['/media/wheretobuy/offcial/h5/25.png', '/media/wheretobuy/offcial/h5/25.png'],
                    link: 'https://backitups.com/ols/categories/ecoflow',
                    isArea: true,
                },
            ],
        },
        ca: {
            country: 'Canada',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/1.webp', '/media/wheretobuy/offcial/h5/1.png'], link: 'https://ca.ecoflow.com/' },
                {
                    img: ['/media/wheretobuy/offcial/h5/14.webp', '/media/wheretobuy/offcial/h5/14.png'],
                    link: 'https://www.amazon.ca/stores/EFECOFLOW/page/20C3DB9D-74BA-4AE9-93C4-D888FC16B7F4?ref_=ast_bln',
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/10.webp', '/media/wheretobuy/offcial/h5/10.png'],
                    link: 'https://www.bestbuy.ca/en-ca/search?search=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/5.webp', '/media/wheretobuy/offcial/h5/5.png'],
                    link: 'https://www.costco.ca/s?langId=-24&keyword=EcoFlow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/h5/15.webp', '/media/wheretobuy/offcial/h5/15.png'],
                //     link: 'https://modularacks.com/pages/search-results-page?q=ecoflow',
                // },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                //     link: 'https://www.harborfreight.com/search?q=EcoFlow',
                // },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                    ],
                    link: 'https://shopsolarkits.com/collections/ecoflow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                //     link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                // },
                {
                    img: ['/media/wheretobuy/offcial/pc/24.webp', '/media/wheretobuy/offcial/pc/24.png'],
                    link: 'https://www.tsc.ca/pages/productresults?dimensions=3004108&rd=1&searchterm=ecoflow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                    ],
                    link: 'https://www.batteriesexpert.com/product_search/?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                    ],
                    link: 'https://www.canadiantire.ca/en/search-results.html?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                    ],
                    link: 'https://www.londondrugs.com/search?q=EcoFlow&autoFiltersApplied=true',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                    ],
                    link: 'https://crazeoutdoors.com/collections/ecoflow?srsltid=AfmBOop8rGGys8_qvsEi0USH12qBCyqzyx5AUZ8N7ZHvJu4cWrSexdhD',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                    ],
                    link: 'https://truoffgrid.com/shop',
                },
            ],
        },
        cn: {
            country: '中国',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/16.webp', '/media/wheretobuy/offcial/h5/16.png'], link: 'https://u.jd.com/xMUCTB1' },
                { img: ['/media/wheretobuy/offcial/h5/19.webp', '/media/wheretobuy/offcial/h5/19.png'], link: 'https://u.jd.com/xMUL3UY' },
                {
                    img: ['/media/wheretobuy/offcial/h5/18.webp', '/media/wheretobuy/offcial/h5/18.png'],
                    bigImg: {
                        img: ['/media/wheretobuy/offcial/h5/18_hover.webp', '/media/wheretobuy/offcial/h5/18_hover.png'],
                        title: t('douyin_title'),
                        desc: t('douyin_desc'),
                        note: [
                            {
                                icon: <EFDownloadPicture width="0.26rem" height="0.26rem" />,
                                text: t('download_savePic'),
                            },
                            {
                                icon: <EFDownloadPhone width="0.26rem" height="0.26rem" />,
                                text: t('download_phone'),
                            },
                        ],
                    },
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/17.webp', '/media/wheretobuy/offcial/h5/17.png'],
                    link: 'https://ecoflow.tmall.com/?spm=a220o.1000855.1997427721.d4918089.37a29352j6oQdE',
                },
            ],
        },
        'cn-hk': {
            country: 'China',
            brands: [
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1762497356232/1.jpeg'],
                    link: 'https://www.futex.hk/',
                },
            ],
        },
    };
    const brandListsCur = brandsMap[locale] || [];
    const onBrandClick = (brand: any) => {
        if (brand?.link) {
            window.open(brand?.link, '_blank');
        }
        if (brand?.bigImg && Object.keys(brand?.bigImg)?.length > 0) {
            setHoverActive(!hoverActive);
        }
    };

    const onChangeSearch = (value: string) => {
        setSearchVar(value);
        if (locale === 'de') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('title'),
                button_name: value === 'zip' ? t('search_item_zip') : t('search_item_address'),
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'option_click',
                button_name: value === 'zip' ? t('search_item_zip') : t('search_item_address'),
            });
        }
    };

    const selectBefore: any = (
        <Select
            defaultValue={searchVar}
            open={expanded}
            onDropdownVisibleChange={setExpanded}
            onChange={(value) => onChangeSearch(value)}
            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
            suffixIcon={
                ['zip', 'text'].includes(searchVar) ? (
                    <>
                        {searchVar === 'zip' ? (
                            <EFZip width=".16rem" height=".16rem" className="svg-icon" />
                        ) : (
                            <EFAddress width=".16rem" height=".16rem" className="svg-icon" />
                        )}
                        <svg
                            className={`svg-arrow ${expanded ? 'open' : 'close'}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width=".12rem"
                            height=".12rem"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <path
                                d="M2.89534 7.69762L5.99995 4.62117L9.10456 7.69762C9.24026 7.83209 9.40735 7.9 9.59995 7.9C9.79255 7.9 9.95964 7.83209 10.0953 7.69762C10.2311 7.56311 10.3 7.39711 10.3 7.20544C10.3 7.01377 10.2311 6.84777 10.0953 6.71326L6.49534 3.14592L6.42627 3.21562L6.49534 3.14592C6.3437 2.99566 6.18141 2.9054 6.0092 2.90023C5.83547 2.89502 5.67503 2.977 5.52956 3.12115L1.90456 6.71326C1.76883 6.84777 1.69995 7.01377 1.69995 7.20544C1.69995 7.39711 1.76883 7.56311 1.90456 7.69762C2.04027 7.83209 2.20735 7.9 2.39995 7.9C2.59255 7.9 2.75964 7.83209 2.89534 7.69762Z"
                                fill="#919191"
                                stroke="#919191"
                                strokeWidth="0.2"
                            />
                        </svg>
                    </>
                ) : null
            }
        >
            <Select.Option value="zip">
                <>
                    <EFZip width=".16rem" height=".16rem" />
                    <span className="option-text">{t('search_item_zip')}</span>
                </>
            </Select.Option>
            <Select.Option value="text">
                <>
                    <EFAddress width=".16rem" height=".16rem" />
                    <span className="option-text">{t('search_item_address')}</span>
                </>
            </Select.Option>
        </Select>
    );

    const onClickTab = (tab: string, tabText: string) => {
        active !== tab && setActive(tab);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: tabText,
        });
    };

    useEffect(() => {
        if (locale !== 'cn') {
            getCountryList(locale).then((res: any) => {
                if (res.code === '0') {
                    setCountryData(res.data);
                }
            });
        }
        // 默认展示当前站点国家
        getStateList({ country: LOCAL_MAP[locale] || locale?.toUpperCase() }, locale).then((res: any) => {
            if (res.code === '0') {
                setSearchCountry(LOCAL_MAP[locale] || locale?.toUpperCase());
                setProvinceData(res.data);
            }
        });
        // 请求省/州
        getStoreList({ country: LOCAL_MAP[locale] || locale?.toUpperCase() }, locale).then((res: any) => {
            if (res.code === '0') {
                // 更新门店数据
                setStoreLists(res.data);
                setCountryStores(res.data);
                setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
                setCurPage(1);
            }
        });
        // 请求类型
        getTypeList({ country: LOCAL_MAP[locale] || locale?.toUpperCase() }, locale).then((res: any) => {
            if (res.code === '0') {
                setTypeData(res.data);
            }
        });
    }, []);

    useEffect(() => {
        const hasZipStore = countryStores?.some((list: any) => Boolean(list?.zipCode));
        if (hasZipStore && SEARCH_VAR_SITES.includes(locale)) {
            !searchVar && setSearchVar('zip');
        } else if (SEARCH_VAR_SITES_STORE.includes(locale)) {
            !searchVar && setSearchVar('text');
        } else {
            setSearchVar('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SEARCH_VAR_SITES, SEARCH_VAR_SITES_STORE, locale, countryStores]);

    return (
        <div className={`whereToBuy_h5 ${css.whereToBuy_h5}`}>
            <h1 className="title"> {t('title')}</h1>
            <div className="subTitle"> {t('subTitle')}</div>
            <div className="tabsContainer">
                {['us', 'cn', 'ca'].includes(locale) && (
                    <div className="tabs">
                        {['us', 'cn'].includes(locale) && (
                            <li className={`${active === 'retail' ? 'active' : ''} tab_item`} onClick={() => onClickTab('retail', t('tab_retailStore'))}>
                                <span className="text">{t('tab_retailStore')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'offcial' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('offcial', t('tab_offcialOnlineStores'))}
                            >
                                <span className="text">{t('tab_offcialOnlineStores')}</span>
                            </li>
                        )}
                        {['us', 'ca'].includes(locale) && (
                            <li className={`${active === 'PR_HI_VK' ? 'active' : ''} tab_item`} onClick={() => onClickTab('PR_HI_VK', t('tab_PR_HI_VK'))}>
                                <span className="text">{t('tab_PR_HI_VK')}</span>
                            </li>
                        )}
                    </div>
                )}
                <div className={`retailStoreBox ${active === 'retail' ? 'active' : ''}`}>
                    <div className="controlBox">
                        {locale !== 'cn' && (
                            <div className="countryBox controlItem">
                                <Select
                                    placeholder={t('placeholder_country')}
                                    notFoundContent={t('select_nodata')}
                                    onChange={onChangeCountry}
                                    onDropdownVisibleChange={(open: boolean) => {
                                        if (open) {
                                            document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                        } else {
                                            document.body.style.overflow = ''; // 恢复外层页面滚动
                                        }
                                        if (open && !countryOpen) {
                                            return setCountryOpen(true);
                                        }
                                        if (!open && countryOpen) {
                                            return setCountryOpen(false);
                                        }
                                    }}
                                    allowClear={true}
                                    onClear={async () => {
                                        if (locale !== 'cn') {
                                            setSearchCountry(null);
                                        }
                                        if (locale === 'cn') {
                                            setSearchCity(null);
                                        }
                                        setSearchProvince(null);
                                        setProvinceData([]);
                                        setSearchType(null);
                                        setTypeData([]);
                                        // 重新请求数据
                                        const params: any = { country: locale?.toUpperCase() };
                                        if (searchText) {
                                            searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
                                        }
                                        const res = await getStoreList(params, locale);
                                        if (res?.code === '0') {
                                            setStoreLists(res.data);
                                            setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
                                            setCurPage(1);
                                        }
                                    }}
                                    value={searchCountry}
                                    options={countryData.map((country: any) => ({ label: country, value: country }))}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <span
                                            style={{
                                                display: 'block',
                                                transition: 'all 0.3s ease-in-out',
                                                transform: countryOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                            }}
                                        >
                                            <EFArrowDown style={{ fontSize: '0.15rem' }} />
                                        </span>
                                    }
                                />
                            </div>
                        )}
                        {provinceData.length > 0 && (
                            <div className="provinceBox controlItem">
                                <Select
                                    placeholder={t('placeholder_province')}
                                    notFoundContent={t('select_nodata')}
                                    onChange={onChangeProvince}
                                    onDropdownVisibleChange={(open: boolean) => {
                                        if (open) {
                                            document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                        } else {
                                            document.body.style.overflow = ''; // 恢复外层页面滚动
                                        }
                                        if (open && !provinceOpen) {
                                            return setProvinceOpen(true);
                                        }
                                        if (!open && provinceOpen) {
                                            return setProvinceOpen(false);
                                        }
                                    }}
                                    allowClear={true}
                                    onClear={async () => {
                                        setSearchProvince(null);
                                        if (locale === 'cn') {
                                            setSearchCity(null);
                                        }
                                        // 重新请求数据
                                        const params: any = { country: searchCountry };
                                        if (searchText) {
                                            searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
                                        }
                                        if (searchType) {
                                            params.type = searchType;
                                        }
                                        const res = await getStoreList(params, locale);
                                        if (res?.code === '0') {
                                            setStoreLists(res.data);
                                            setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
                                            setCurPage(1);
                                        }
                                    }}
                                    value={searchProvince}
                                    options={provinceData.map((province: any) => ({ label: province, value: province }))}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <span
                                            style={{
                                                display: 'block',
                                                transition: 'all 0.3s ease-in-out',
                                                transform: provinceOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                            }}
                                        >
                                            <EFArrowDown style={{ fontSize: '0.15rem' }} />
                                        </span>
                                    }
                                />
                            </div>
                        )}
                        {locale === 'cn' && (
                            <div className="cityBox controlItem">
                                <Select
                                    placeholder={t('placeholder_city')}
                                    notFoundContent={t('select_nodata')}
                                    onChange={onChangeCity}
                                    onDropdownVisibleChange={(open: boolean) => {
                                        if (open) {
                                            document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                        } else {
                                            document.body.style.overflow = ''; // 恢复外层页面滚动
                                        }
                                        if (open && !cityOpen) {
                                            return setCityOpen(true);
                                        }
                                        if (!open && cityOpen) {
                                            return setCityOpen(false);
                                        }
                                    }}
                                    allowClear={true}
                                    onClear={async () => {
                                        setSearchCity(null);
                                        // 重新请求数据
                                        const params: any = { country: searchCountry, state: searchProvince };
                                        if (searchText) {
                                            searchVar === 'zip' ? (params.zipCode = searchText) : (params.fuzzyStr = searchText);
                                        }
                                        if (searchType) {
                                            params.type = searchType;
                                        }
                                        const res = await getStoreList(params, locale);
                                        if (res?.code === '0') {
                                            setStoreLists(res.data);
                                            setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
                                            setCurPage(1);
                                        }
                                    }}
                                    value={searchCity}
                                    options={cityData.map((city: any) => ({ label: city, value: city }))}
                                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                    suffixIcon={
                                        <span
                                            style={{
                                                display: 'block',
                                                transition: 'all 0.3s ease-in-out',
                                                transform: cityOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                            }}
                                        >
                                            <EFArrowDown style={{ fontSize: '0.15rem' }} />
                                        </span>
                                    }
                                />
                            </div>
                        )}
                        <div className="storeBox controlItem">
                            <Select
                                placeholder={t('placeholder_type')}
                                notFoundContent={t('select_nodata')}
                                onChange={onChangeType}
                                onDropdownVisibleChange={(open: boolean) => {
                                    if (open) {
                                        document.body.style.overflow = 'hidden'; // 阻止外层页面滚动
                                    } else {
                                        document.body.style.overflow = ''; // 恢复外层页面滚动
                                    }
                                    if (open && !typeOpen) {
                                        return setTypeOpen(true);
                                    }
                                    if (!open && typeOpen) {
                                        return setTypeOpen(false);
                                    }
                                }}
                                allowClear={true}
                                onClear={async () => {
                                    setSearchType(null);
                                    // 重新请求数据
                                    const params: any = { country: searchCountry };
                                    if (searchProvince) {
                                        params.state = searchProvince;
                                    }
                                    if (searchCity) {
                                        params.city = searchCity;
                                    }
                                    const res = await getStoreList(params, locale);
                                    if (res?.code === '0') {
                                        setStoreLists(res.data);
                                        setCurPageStores(res.data.slice(0, PER_PAGE_MAX));
                                        setCurPage(1);
                                    }
                                }}
                                value={searchType}
                                options={typeData.map((type: any) => ({ label: type, value: type }))}
                                getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                suffixIcon={
                                    <span
                                        style={{
                                            display: 'block',
                                            transition: 'all 0.3s ease-in-out',
                                            transform: typeOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                        }}
                                    >
                                        <EFArrowDown style={{ fontSize: '0.15rem' }} />
                                    </span>
                                }
                            />
                        </div>
                        <div className="searchBox controlItem">
                            <Input.Search
                                className={`${(SEARCH_VAR_SITES.includes(locale) || SEARCH_VAR_SITES_STORE.includes(locale)) && searchVar ? 'search-var' : ''}`}
                                addonBefore={(SEARCH_VAR_SITES.includes(locale) || SEARCH_VAR_SITES_STORE.includes(locale)) && searchVar ? selectBefore : null}
                                placeholder={searchVar === 'zip' ? t('placeholder_search_zip') : t('placeholder_search_address')}
                                size="large"
                                onSearch={onSearch}
                                onChange={onSearchChange}
                            />
                        </div>
                    </div>
                    <div className="resultBox">
                        {curPageStores?.map((storeList: any, k: number) => (
                            <li className="store_item" key={`${storeList?.latitude}_${storeList.longitude}_record_${k}`}>
                                {storeList?.name && <div className="store_name">{storeList?.name}</div>}
                                {storeList?.address && !storeList?.virtualFlag && (
                                    <div className="store_address common">
                                        <div className="icon">
                                            <EFLocation />
                                        </div>
                                        <div className="text">{storeList?.address}</div>
                                    </div>
                                )}
                                {storeList?.phone && (
                                    <div className="store_phone common">
                                        <div className="icon">
                                            <EFPhone />
                                        </div>
                                        <a className="text" href={`tel:${storeList?.phone}`}>
                                            {storeList?.phone}
                                        </a>
                                    </div>
                                )}
                                {storeList?.email && (
                                    <div className="store_email common">
                                        <div className="icon">
                                            <EFEmail />
                                        </div>
                                        <a className="text" href={`mailto:${storeList?.email}`}>
                                            {storeList?.email}
                                        </a>
                                    </div>
                                )}
                                {storeList?.webLink && (
                                    <div className="store_website common">
                                        <div className="icon">
                                            <EFGlobal />
                                        </div>
                                        <a className="text" href={storeList?.webLink} target="_blank" rel="noreferrer">
                                            {storeList?.webLink}
                                        </a>
                                    </div>
                                )}
                                {storeList?.businessTime && (
                                    <div className="store_openTime common">
                                        <div className="icon">
                                            <EFClock />
                                        </div>
                                        <div className="text">{storeList?.businessTime}</div>
                                    </div>
                                )}
                                {storeList?.label && (
                                    <div className="store_tags">
                                        {storeList?.label?.split(';')?.map((tag: any, m: number) => (
                                            <li className="store_tag_item" key={`${storeList.latitude}_${storeList.longitude}_record_${k}_tag_${m}`}>
                                                {tag}
                                            </li>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                        {curPageStores?.length === 0 && (
                            <div className="noDataBox">
                                <EFNoData width="1.8rem" height="1.2rem" />
                                <div className="noData">{t('noData')}</div>
                            </div>
                        )}
                        {curPageStores?.length > 0 && (
                            <div className="pagenation">
                                <div className={`leftIcon ${curPage === 1 ? 'disable' : ''}`} onClick={onPrevPage}>
                                    <EFPageArrow />
                                </div>
                                <div className="middleBox">
                                    <span className="pages">
                                        {curPage}/{Math.ceil(storeLists.length / PER_PAGE_MAX)}
                                    </span>
                                    <span className="total">
                                        {storeLists.length === 1
                                            ? t.rich('total_single', {
                                                  total: storeLists.length,
                                              })
                                            : t.rich('total', {
                                                  total: storeLists.length,
                                              })}
                                    </span>
                                </div>
                                <div className={`rightIcon ${curPage === Math.ceil(storeLists.length / PER_PAGE_MAX) ? 'disable' : ''}`} onClick={onNextPage}>
                                    <EFPageArrow />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={`offcailOnlineStores ${active === 'offcial' ? 'active' : ''}`}>
                    {Object.keys(brandListsCur)?.length > 0 && (
                        <ul className="brands">
                            <div className="countryName">
                                <div className="country">{brandListsCur?.country}</div>
                            </div>
                            {brandListsCur?.brands?.map((brand: any, k: number) => (
                                <li className={`brandList ${brand?.link ? '' : 'noLink'}`} key={`curCountry_${k}`} onClick={() => onBrandClick(brand)}>
                                    <EFPic src={brand?.img} alt="" aria-label="" />
                                    {brand?.bigImg && (
                                        <div className={`brandHoverBox ${hoverActive ? 'active' : ''}`}>
                                            <div className="hoverImg">
                                                <EFPic src={brand?.bigImg?.img} alt={brand?.bigImg?.title} aria-label={brand?.bigImg?.title} />
                                            </div>
                                            <p className="hoverTitle">{brand?.bigImg?.title}</p>
                                            <p className="hoverDesc">{brand?.bigImg?.desc}</p>
                                            <div className="noteBox">
                                                {brand?.bigImg?.note?.map((noteItem: any, m: number) => (
                                                    <div className="noteItem" key={m}>
                                                        <div className="noteIcon">{noteItem?.icon}</div>
                                                        <div className="noteText">{noteItem.text}</div>
                                                        {m === 0 && (
                                                            <div className="noteArrow">
                                                                <EFDownloadArrow width="0.16rem" height="0.1rem" />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                    {locale !== 'cn' &&
                        Object.keys(brandsMap)
                            ?.filter((key: string) => key !== locale && key !== 'cn' && brandsMap[key]?.brands?.length > 0)
                            ?.map((country: any) => (
                                <ul className="brands" key={`otherCountry_${country}`}>
                                    <div className="countryName">
                                        <div className="country">{brandsMap[country]?.country}</div>
                                    </div>
                                    {brandsMap[country]?.brands?.map((brand: any, k: number) => (
                                        <li
                                            className={`brandList ${brand?.link ? '' : 'noLink'}`}
                                            key={`${country}_brand_${k}`}
                                            onClick={() => onBrandClick(brand)}
                                        >
                                            <EFPic src={brand?.img} alt="" aria-label="" />
                                        </li>
                                    ))}
                                </ul>
                            ))}
                </div>
                <div className={`PRHIVKBox ${active === 'PR_HI_VK' ? 'active' : ''}`}>
                    <div className="PRHIVK">
                        <ul className="store-lists">
                            {stores?.map((store: any, k: number) => (
                                <li className="store-list" key={k}>
                                    <div className="list-img-box">
                                        <NextImage
                                            src={require(`@publicLocal/where-to-buy/h5/${store.img}`)}
                                            alt={store.storeName}
                                            aria-label={store.storeName}
                                            placeholder="blur"
                                        />
                                        <p className="list-state">{store.state}</p>
                                    </div>
                                    <div className="list-text-box">
                                        <p className="list-store-name">{store.storeName}</p>
                                        {store?.address && !store?.virtualFlag && (
                                            <div className="store-address common">
                                                <div className="icon">
                                                    <EFLocation />
                                                </div>
                                                {store?.address.trim().startsWith('https://') ? (
                                                    <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                                        {store?.address}
                                                    </a>
                                                ) : (
                                                    <div className="text">{store?.address}</div>
                                                )}
                                            </div>
                                        )}
                                        {store?.tel && (
                                            <div className="store-tel common">
                                                <div className="icon">
                                                    <EFPhone />
                                                </div>
                                                <a className="text" href={`tel:${store?.tel}`}>
                                                    {store?.tel}
                                                </a>
                                            </div>
                                        )}
                                        {store?.link && (
                                            <div className="store-link common">
                                                <div className="icon">
                                                    <EFGlobal />
                                                </div>
                                                <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                                    {store?.link}
                                                </a>
                                            </div>
                                        )}
                                        {store?.time && (
                                            <div className="store-time common">
                                                <div className="icon">
                                                    <EFClock />
                                                </div>
                                                <div className="text">{store?.time}</div>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                        {stores?.length > 0 && (
                            <div className="pagenation">
                                <div className={`left-icon ${curPage1 === 1 ? 'disable' : ''}`} onClick={onPrevPage1}>
                                    <EFPageArrow />
                                </div>
                                <div className="middle-box">
                                    <span className="pages">
                                        {curPage1}/{Math.ceil(storesAll.length / PAGE_NUM)}
                                    </span>
                                    <span className="total">
                                        {storesAll.length === 1
                                            ? t.rich('total_single', {
                                                  total: storesAll.length,
                                              })
                                            : t.rich('total', {
                                                  total: storesAll.length,
                                              })}
                                    </span>
                                </div>
                                <div className={`right-icon ${curPage1 === Math.ceil(storesAll.length / PAGE_NUM) ? 'disable' : ''}`} onClick={onNextPage1}>
                                    <EFPageArrow />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
